<template>
  <div class="swipe-container">
    <van-swipe
      :autoplay="3000"
      :duration="250"
      indicator-color="white"
      :height="swipeHeight"
      @change="onChange"
      ref="swipe"
    >
      <van-swipe-item
        v-for="(episode, index) in episodes"
        :key="index"
        class="swipe-item"
        @click="onClick(episode.id, $event)"
      >
        <Photo
          source="cdn"
          :img-id="episode.poster"
          width="100%"
          height="swipeHeight"
          radius="5px"
        />
        <!-- <van-image
          :src="image"
          fit="cover"
          height="130"
          radius="5"
        /> -->
      </van-swipe-item>
      <!-- <div class="custom-indicator" slot="indicator">
        {{ current + 1 }}/4
      </div> -->
    </van-swipe>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { Swipe, SwipeItem } from 'vant'
  // import { Toast } from 'vant'
  import { Image } from 'vant'
  import Photo from './photo.vue'
  Vue.use(Swipe).use(SwipeItem)
  Vue.use(Image)
  // Vue.use(Toast)

  export default {
    components: {
      Photo
    },
    props: {
      slug: String,
      reload: Boolean
    },
    watch: {
      'reload' () {
        window.console.log("reload发生变化")
      },
      'slug' (newVal, oldVal) {
        if (newVal && newVal != oldVal) {
          this.loadData()
        }
      }
    },
    computed: {
      swipeHeight () {
        return this.swipeWidth / 3.2
      }
    },
    data () {
      return {
        swipeWidth: 0,
        limit: 5,  // 从
        current: 0,
        episodes: []
      }
    },
    mounted () {
    },
    methods: {
      onChange () {
      },
      onClick (episodeId, event) {
        window.console.log("点击轮播图")
        window.console.log(episodeId)
        window.console.log(event)
        this.$router.replace({
          name: 'EpisodeDetail',
          params: {
            episodeId: episodeId
          }
        })
      },
      loadData () {
        let that = this
        let params = {
          slug: that.slug,
          editorchoice: true
        }
        that.$nextTick(function() {
          that.swipeWidth = that.$refs.swipe.computedWidth
        })
        that.$api.episode.list(params).then(res => {
          window.console.log("获得了推荐episodes:")
          window.console.log(res)
          if (that.limit > 0) {
            that.episodes = res.data.results.slice(0, that.limit)
          } else {
            that.episodes = res.data.results
          }
        })
      }
    }
  }
</script>

<style lang="css" scoped>
  .swipe-container {
    background: #fff;
    padding: 16px;
  }
  .swipe-item {
    background: #fff;
  }
  .custom-indicator {
    position: absolute;
    right: 5px;
    bottom: 5px;
    padding: 2px 5px;
    font-size: 12px;
    color: #fff;
    /* background: #fff; */
  }
</style>
